module.exports = __webpack_public_path__ + "img/zifei.2f5e45f5.png";